import {useNavigationState} from '@react-navigation/native'

import {getCurrentRoute} from '#/lib/routes/helpers'

export function useNavigationTabState() {
  try {
    return useNavigationState(state => {
      let currentRoute = state ? getCurrentRoute(state).name : 'Home'
      return {
        isAtHome: currentRoute === 'Home',
        isAtSearch: currentRoute === 'Search',
        isAtNotifications: currentRoute === 'Notifications',
        isAtMyProfile: currentRoute === 'MyProfile',
        isAtMessages: currentRoute === 'Messages',
      }
    })
  } catch (e) {
    const location = window.location.pathname
    return {
      isAtHome: location === '/',
      isAtSearch: location === '/search',
      isAtFeeds: location === '/feeds',
      isAtBookmarks: location === '/saved',
      isAtNotifications: location === '/notifications',
      isAtMyProfile: location === '/profile',
      isAtMessages: location === '/messages',
    }
  }
}
